import { DrugCoverageTableGroupOption } from './DrugCoverageTables.Type';
import { PlanAdditionalBenefits } from './PlanAdditionalBenefits.Type';
import { PlanDetailEntry } from './PlanDetailGroup.Type';
import { PlanDocument } from './PlanDocuments.Type';
import { PlanFeatureEntry } from './PlanFeaturedEntries.Type';
import { PlanType } from './PlanTypes.Type';
import { PlanYear } from './PlanYear.Type';
import { StarRating } from './StarRatings.Type';

export type Plan = {
  id: string;
  planName: {
    value: string;
  };

  planDescription: string;
  counties: Array<string>;
  planYear: {
    targetId: string;
    targetItem: PlanYear;
  };

  planType: {
    targetId: string;
    targetItem: PlanType;
  };

  starRating: {
    targetId: string;
    targetItem: StarRating;
  };

  documents: Array<PlanDocument>;
  featuredPlanEntries: Array<PlanFeatureEntry>;
  planDetailEntries: Array<PlanDetailEntry>;
  prescriptionDrugTables: DrugCoverageTableGroupOption;
  contract: string;
  groupId: string;
  pbp: string;
  cavulusPlanName: string;
  additionalBenefits: PlanAdditionalBenefits;
};
